// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.include_stamp_attachment[data-v-28a8eeda] {\n  background-color: rgba(0, 0, 0, 0.12) !important;\n  color: rgba(0, 0, 0, 0.26) !important;\n}\n", ""]);
// Exports
module.exports = exports;
